import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Avatar, Space } from "antd";
import { Text } from "components/UI";

const UnsupportedMessage = () => {
  return (
    <Space className="bg-gray-200 p-3 rounded-lg">
      <Avatar className="bg-red-400" icon={<ExclamationCircleOutlined />} />
      <Text>Unsupported media</Text>
    </Space>
  );
};

export default UnsupportedMessage;
